import { useSidebarStore } from '@/entities/map'
import { eventManager } from '@/shared/lib'

export const useToggleRoomList = () => {
  const isOpen = useSidebarStore(state => state.isOpen)
  const actions = useSidebarStore(state => state.actions)

  const toggle = () => {
    actions.toggle()

    setTimeout(() => {
      eventManager.triggerEvent('resize')
    }, 0)
  }

  return { isOpen, toggle }
}
